import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import KpsEditor from "../editor/KpsEditor";
import Popover from "@material-ui/core/Popover";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import Typography from "@material-ui/core/Typography";
import EntryUserBubble from "./EntryUserBubble";
import DisplayExpertQuestionTemplate from "../expert-questions/DisplayExpertQuestionTemplate";
import { Trans } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import ButtonMenu from "../ButtonMenu";
import ErrorIcon from "@material-ui/icons/Error";

import AreYouSureDialog from "../dialog/AreYouSureDialog";
import SettingsEthernetIcon from "@material-ui/icons/SettingsEthernet";
import { discussionClient, attachmentClient } from "../../AxiosClient";
import IconButton from "@material-ui/core/IconButton";
import { mdiContentDuplicate } from "@mdi/js";
import Icon from "@mdi/react";
import { addContent } from "../../redux/actions/editorActions";
import DisplayUser from "../../components/user/DisplayUser";
import Avatar from "@material-ui/core/Avatar";
import cache from "../../CacheClient";

const styles = (theme) => ({
  myMessageInput: {
    color: "white",
    "&:before": {
      borderColor: "white",
    },
    "&:after": {
      borderColor: "white",
    },
  },
  otherMessageInput: {
    color: "black",
  },
  bubble: {
    backgroundColor: "#0048AA",
    borderRadius: "5px",
    boxShadow: "0 0 6px #B2B2B2",
    display: "block",
    padding: "10px 18px",
    position: "relative",
    verticalAlign: "top",
    color: "black",
    wordWrap: "break-word",
  },
  bubbleContainer: {
    marginTop: "16px",
    marginBottom: 0,
    display: "flex",
    fontFamily: "sans-serif",
    fontSize: "14px",
  },
  timeDate: {
    flexGrow: 1,
    display: "flex",
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
    color: theme.palette.text.secondary,
    display: "flex",
    position: "relative",
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
});

export class EntryBubble extends Component {
  static propTypes = {};
  constructor(props) {
    super(props);
    this.state = {
      entry: {},
      openPopover: false,
      anchor: null,
      menuVisibility: "hidden",
      showEdit: false,
      openAreYouSure: false,
      menuOpen: false,
      avatarContent: null,
    };
  }
  componentDidMount() {
    this.props.user &&
      this.props.user.hasOwnProperty("avatarURI") &&
      this.props.user.avatarURI &&
      this.getAvatarContent();
  }
  handleClick = (event) => {
    this.setState({ openPopover: true, anchor: event.currentTarget });
  };
  renderMenu = (canModerate) => {
    return (
      <div id="menu">
        {canModerate && (
          <ButtonMenu
            ariaLabel="Entry options"
            open={this.state.menuOpen}
            onOpen={() => this.setState({ menuOpen: true })}
            onClose={() => this.setState({ menuOpen: false })}
          >
            <MenuItem
              onClick={() => {
                this.setState({ menuOpen: false });
                this.props.editEntry(this.props.entry);
              }}
            >
              <Trans i18nKey="portlet_attachment_edit_text" />
            </MenuItem>
            {!this.props.entry.isOriginalEntry && (
              <MenuItem onClick={() => this.setState({ openAreYouSure: true })}>
                <Trans i18nKey="portlet_attachment_delete_text" />
              </MenuItem>
            )}
          </ButtonMenu>
        )}
      </div>
    );
  };
  stringToColor = (string) => {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let colour = "";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      colour += `00${value.toString(16)}`.substr(-2);
    }
    /* eslint-enable no-bitwise */

    if (parseInt(colour, 16) > 15658734) return "#eeeeee";
    return `#${colour}`;
  };
  getAvatarContent = () => {
    let avatarURI = this.props.isMyMessage
      ? this.props.user.avatarURI
        ? this.props.user.avatarURI
        : null
      : this.props.entry.postUser.avatarURI
        ? this.props.entry.postUser.avatarURI
        : null;

    if(avatarURI !== null){ 
      let cached = cache.get(`attachment-${avatarURI}`);
      if(!cached){
        attachmentClient
          .get(`/attachment/${avatarURI}/content/`, {
            responseType: "blob",
          })
          .then((res) => {
            let reader = new FileReader();
            reader.readAsDataURL(res.data);
            reader.onloadend = () => {
              let base64data = reader.result;
              this.setState({ avatarContent: base64data });
              cache.put(`attachment-${avatarURI}`, base64data);
            };
          })
          .catch((err) => {
            this.setState({ avatarContent: null });
          });
      } else {
        this.setState({ avatarContent: cached });
      }
    }
  };
  render() {
    const { classes } = this.props;
    // const data =
    //   "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";
    // const Avatar = ({ data }) => (
    //   <img
    //     style={{ height: "60px", width: "60px" }}
    //     src={`data:image/jpeg;base64,${data}`}
    //   />
    // );
    // let date = Date.parse(this.props.entry.editTime);
    const avatarUser = this.props.isMyMessage
      ? this.props.user
      : this.props.entry.postUser;
    const AvatarElement = (
      <Avatar
        alt={this.props.user.firstName + " " + avatarUser.surname}
        src={this.state.avatarContent !== null && this.state.avatarContent}
        className={classes.large}
        style={
          avatarUser.userLogin
            ? { backgroundColor: this.stringToColor(avatarUser.userLogin) }
            : { backgroundColor: "#eeeeee" }
        }
      >
        {avatarUser.firstName &&
          avatarUser.surname &&
          avatarUser.firstName.substring(0, 1) +
            avatarUser.surname.substring(0, 1)}
      </Avatar>
    );
    let canModerate =
      this.props.user.userPermits.roles.forumModerator ||
      this.props.user.userPermits.roles.administrator ||
      this.props.user.userPermits.roles.administrator.systemManager;
    const align = this.props.isMyMessage ? "flex-end" : "auto";
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: 16,
        }}
        data-testid="entry-bubble"
        onMouseEnter={() => this.setState({ menuVisibility: "visible" })}
        onMouseLeave={() => this.setState({ menuVisibility: "hidden" })}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <div
            className={classes.bubbleContainer}
            style={{
              alignSelf: align,
              flexGrow: 1,
              flex: 1,
              flexDirection: "row",
              width: "100%",
              justifyContent: this.props.isMyMessage
                ? "flex-end"
                : "flex-start",
            }}
          >
            <Popover
              anchorEl={this.state.anchor}
              anchorOrigin={
                this.props.isMyMessage
                  ? {
                      vertical: "top",
                      horizontal: "left",
                    }
                  : {
                      vertical: "top",
                      horizontal: "right",
                    }
              }
              transformOrigin={
                this.props.isMyMessage
                  ? {
                      vertical: "bottom",
                      horizontal: "right",
                    }
                  : {
                      vertical: "bottom",
                      horizontal: "left",
                    }
              }
              onClose={() => this.setState({ openPopover: false })}
              open={this.state.openPopover}
            >
              <EntryUserBubble
                entry={this.props.entry}
                close={(e) => {
                  this.setState({ openPopover: false });
                  e.stopPropagation();
                }}
              />
            </Popover>
            {!this.props.isMyMessage && (
              <Tooltip
                title={
                  <Typography>
                    <DisplayUser user={this.props.entry.postUser} />
                  </Typography>
                }
                aria-label={
                  this.props.entry.postUser.firstName +
                  " " +
                  this.props.entry.postUser.surname +
                  "(" +
                  this.props.entry.postUser.userLogin +
                  ")"
                }
              >
                <div
                  style={{ cursor: "pointer", marginTop: 8 }}
                  // onClick={this.handleClick}
                >
                  <>{AvatarElement}</>
                </div>
              </Tooltip>
            )}

            <div
              style={{
                display: "flex",
                // width: "100%",
                flexDirection: "column",
                marginLeft: this.props.isMyMessage ? 0 : 8,
                marginRight: this.props.isMyMessage ? 8 : 0,
                flexBasis: this.props.expert ? "50%" : "",
                overflow: "auto",
              }}
            >
              <Paper
                elevation={2}
                style={{
                  maxWidth: "100%",
                  overflow: "auto",
                  padding: 8,
                  backgroundColor: this.props.isMyMessage ? "#0048AA" : "#eee",
                  display: "flex",
                  borderRadius: this.props.isMyMessage
                    ? "30px 30px 0px 30px"
                    : "30px 30px 30px 0px",
                  margin: 8,
                  marginBottom: 0,
                  paddingLeft: this.props.isMyMessage ? 10 : 20,
                  paddingRight: this.props.isMyMessage
                    ? 20
                    : canModerate
                      ? this.props.expert
                        ? 20
                        : 10
                      : 20,
                  paddingTop: 2,
                  paddingBottom: 2,
                  color: this.props.isMyMessage ? "white" : "black",
                }}
              >
                {this.props.isMyMessage &&
                  this.props.numberOfOpen > 0 && (
                    <div>
                      <Tooltip
                        title={
                          <Typography>
                            <Trans i18nKey="discussion_entry_copy_content" />
                          </Typography>
                        }
                      >
                        <IconButton
                          onClick={() =>
                            this.props.addContent(
                              this.props.entry.text,
                              this.props.entry.attachmentIds
                            )
                          }
                          style={{ color: this.props.isMyMessage && "white" }}
                        >
                          <Icon path={mdiContentDuplicate} size={1} />
                        </IconButton>
                      </Tooltip>
                    </div>
                  )}
                {this.props.isMyMessage &&
                  canModerate &&
                  !this.props.expert &&
                  this.renderMenu(canModerate)}
                {!this.props.expert ? (
                  <KpsEditor initialContent={this.props.entry.text} readOnly />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    {JSON.parse(this.props.entry.text).map((section) => (
                      <DisplayExpertQuestionTemplate
                        entry
                        inputClass={
                          this.props.isMyMessage
                            ? classes.myMessageInput
                            : classes.otherMessageInput
                        }
                        data={section}
                        changeValue={this.changeValue}
                      />
                    ))}
                  </div>
                )}
                {!this.props.isMyMessage &&
                  !this.props.expert &&
                  canModerate &&
                  this.renderMenu(canModerate)}
                {this.props.numberOfOpen > 0 &&
                  !this.props.isMyMessage && (
                    <div>
                      <IconButton
                        onClick={() =>
                          this.props.addContent(
                            this.props.entry.text,
                            this.props.entry.attachmentIds
                          )
                        }
                      >
                        <Icon path={mdiContentDuplicate} size={1} />
                      </IconButton>
                    </div>
                  )}
              </Paper>
            </div>
            <Tooltip
              title={
                <Typography>
                  <DisplayUser user={this.props.entry.postUser} />
                </Typography>
              }
              aria-label={
                this.props.entry.postUser.firstName +
                " " +
                this.props.entry.postUser.surname +
                "(" +
                this.props.entry.postUser.userLogin +
                ")"
              }
            >
              <div
                style={{ cursor: "pointer", marginTop: 8 }}
                // onClick={this.handleClick}
              >
                {this.props.isMyMessage && <>{AvatarElement}</>}
              </div>
            </Tooltip>
          </div>
        </div>
        <div
          className={classes.timeDate}
          style={{
            alignSelf: align,
            justifyContent: this.props.isMyMessage ? "flex-end" : "flex-start",
            paddingRight: this.props.isMyMessage ? 78 : 0,
            paddingLeft: this.props.isMyMessage ? 0 : 78,
          }}
        >
          {this.props.entry.editCount > 0 && (
            <Tooltip
              title={
                <Typography>
                  {`Last edited ${moment(this.props.entry.editTime).format(
                    "lll"
                  )}`}
                </Typography>
              }
            >
              <ErrorIcon style={{ paddingRight: 6 }} />
            </Tooltip>
          )}
          <Typography
            style={{ margin: "auto", marginLeft: 0, marginRight: 0 }}
            variant="caption"
          >
            {moment(this.props.entry.time).format("lll")}
          </Typography>
        </div>
        {this.state.openAreYouSure && (
          <AreYouSureDialog
            open={this.state.openAreYouSure}
            onClose={() => this.setState({ openAreYouSure: false })}
            onSubmit={this.delete}
          >
            Are you sure you want to delete this entry?
          </AreYouSureDialog>
        )}
      </div>
    );
  }
  changeValue = (value, id) => {};
  delete = () => {
    discussionClient
      .delete(`/entry/${this.props.entry.entryId}`)
      .then((res) => {
        this.setState({ openAreYouSure: false });
        this.props.removeEntry(this.props.entry);
      });
  };
}
const mapStateToProps = (state) => ({
  user: state.user.currentUser,
  numberOfOpen: state.editor.openForWork,
});
const mapDispatchToProps = {
  addContent,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(EntryBubble));
